export const buttons = [
  /* TODO Implement business logic supporting these options
    {
        name: 'separator',
        icon: 'Line-white.svg',
        hasActiveState: true
    },
    {
        name: 'font',
        icon: 'SansSerif-white.svg',
        secIcon: 'Serif-white.svg',
        hasActiveState: false
    },
    */
  {
    name: 'rearrange',
    icon: 'Rearrange2-white.svg',
    hasActiveState: true,
  },
  {
    name: 'paint',
    icon: 'Paint-white.svg',
    hasActiveState: false,
  },
];
